import { useAccountStore } from "@/stores/accountStore";
import { getAccessToken, isOAuthSession } from "@/stores/authStore";

export const getCredentialHeaders = (): Record<string, string> => {
    if (isOAuthSession()) {
        const accessToken = getAccessToken();
        return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
    }

    const { apiKey } = useAccountStore.getState();
    return apiKey ? { "X-API-KEY": apiKey } : {};
};
